export default __webpack_public_path__ + "media/images/features/ana/title_left-c8877d61443f5fc63ab2e06562d13535.png";